<script>
  import { ignore } from "../Common/tools";
  import { onMount, onDestroy } from "svelte";
  import Row from "./Row.svelte";
  import TableHead from "./TableHead.svelte";
  import {External, M} from "../external";

  export let data,
    selection = null,
    activeColumns,
    loading,
    hideHeadOnLoad = false,
    tableType = "",
    nextPage = ignore,
    onClick = ignore,
    onOrder = ignore,
    hasSelection = true,
    tableClass = "",
    selectionField = "id";

  let instance, tableControl;

  export function addRows(newRows) {
    data.push.apply(data, newRows);
    data = data;
    setTimeout(() => {
      tableControl.refresh();
    });
  }

  export function updateRow(updatedRow) {
    let idx = data.findIndex((row) => row.id === updatedRow.id);
    if (idx >= 0) {
      const oldRow = data[idx];
      const newRow = {
        ...oldRow,
        ...updatedRow
      };
      const tableData = [...data];
      tableData[idx] = newRow;
      data = tableData;
      setTimeout(() => {
        tableControl.refresh();
      });
    }
  }

  export function refreshRowById(rowId) {
    if (selectionField === undefined || selectionField === null) {
      selectionField = 'id';
    }
    let idx = data.findIndex((row) => row[selectionField] === rowId);
    if (idx >= 0) {
      data[idx] = data[idx];
    }
  }

  export function removeRowById(rowId) {
    if (selectionField === undefined || selectionField === null) {
      selectionField = 'id';
    }
    let idx = data.findIndex((row) => row[selectionField] === rowId);
    if (idx >= 0) {
      data.splice(idx, 1);
      data = data;
      setTimeout(() => {
        tableControl.refresh();
      });
    }
  }

  onMount(function () {});

  onDestroy(function () {
    if (nextPage !== ignore && instance) {
      let jTable = External.$(instance);
      tableControl = null;
      External.UITools.destroyAutoResizableLazyLoadingTable(jTable);
    }
    External.$(".account-settings").not(".scrollable-settings").css("overflow-y", "visible");
  });

  $: if (instance) {
    if (nextPage !== ignore) {
      let jTable = External.$(instance);

      tableControl = External.UITools.createAutoResizableLazyLoadingTable({
        scrollBody: jTable.find("tbody"),
        calcHorizontalScrollHeight: function (scrollBody) {
          return jTable.height() - scrollBody.closest("table").height();
        },
        atBottom: function () {
          nextPage(jTable);
        }
      });
    }
    External.$(".account-settings").not(".scrollable-settings").css("overflow-y", "hidden");
  }

  export function scrollIntoView(rowId) {
    setTimeout(() => {
      if (!instance) {
        return;
      }
      let row = instance.querySelector(`[data-id="${rowId}"]`);
      if (row) {
        row.scrollIntoView({
          behavior: "auto",
          block: "center"
        });
        row.classList.add("highlight");
        setTimeout(() => {
          row.classList.add("highlight-end");
        }, 100);
      }
    }, 50);
  }

  let refreshTableHeight = () => {
    if (tableControl) {
      tableControl.recalcHeight();
    }
  };

  $: !loading && refreshTableHeight();
</script>

{#if !loading && data.length === 0}
  <slot>
    <div class="text-center col20 f-left" style="padding: 70px 30px; box-sizing: border-box;">
      <h4 class="col20 f-left t-center mb-15">{M.NO_DATA_AVAILABLE}</h4>
    </div>
  </slot>
{:else}
  <div class={"scrollable-table " + (tableClass ? tableClass : "")} class:loading class:with-selection={selection !== null} bind:this={instance}>
    <table style="margin-top: 0;">
      {#if !hideHeadOnLoad || !loading || data.length > 0}
        <thead>
          <TableHead data={activeColumns} bind:selection tableType={tableType} hasSelection={hasSelection} onOrder={onOrder} />
        </thead>
      {/if}
      <tbody>
        {#if data.length > 0}
          {#each data as row (row)}
            <Row data={row} activeColumns={activeColumns} bind:selection tableType={tableType} onClick={onClick}
                 hasCheckbox={hasSelection} idField={selectionField} />
          {/each}
        {/if}
        {#if loading}
          <tr style="display: block; width: 100%;" class="loader-tr">
            <td style="display: block; width: 100%; max-width: 100%;">
              <div class="small-centered-loading-icon" />
            </td>
          </tr>
        {/if}
      </tbody>
    </table>
  </div>
{/if}
